import { all, put, takeLatest } from 'redux-saga/effects'
import { ActionType, getType } from 'typesafe-actions'

import { createOrganization } from '../../../../../data/organizations/actions'
import { submitAddOrganizationForm } from './actions'

export function* addOrganizationModalSaga() {
  yield all([takeLatest(getType(submitAddOrganizationForm), sendCreateOrganizationAction)])
}

function* sendCreateOrganizationAction(action: ActionType<typeof submitAddOrganizationForm>) {
  const { organization, isCreated } = action.payload
  yield put(
    createOrganization.request({
      organization,
      isCreated,
    })
  )
}
